// extracted by mini-css-extract-plugin
export default {"action":"cards_action__ighCn","completed":"cards_completed__pKeL5","slide-in-bottom":"cards_slide-in-bottom__7z-uk"};